import DEFAULT from '@/config/premadeConfigs'
import {
  BOOK_APPOINTMENT,
  CHECK_SYMPTOMS,
  PRESCRIPTION,
} from '@/config/premadeConfigs/USA/productFeatures'
import { PartnerConfig } from '@/types'
import { CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { WELCOME, REGISTRATION, SUMMARY } = USA.CONTENT

const partnerName = 'Health Net Medi-Cal'
const planName = 'Health Net Medi-Cal'

const hnmc: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    id: 'centene-ca-medi-cal',
    productConfigAppName: 'centene-ca-medi-cal',
    name: partnerName,
    codes: {
      membership: 'HNMC',
    },
    partnerUrlSlug: 'health-net-medi-cal',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: (WELCOME.enUS.copy as CopyFunction)(planName),
          productFeatures: [
            CHECK_SYMPTOMS.enUS,
            {
              ...BOOK_APPOINTMENT.enUS,
              title:
                'Book a video appointment to talk to a doctor 24 hours a day, 7 days a week or a therapist Monday - Friday 7am-7pm',
            },
            {
              ...PRESCRIPTION.enUS,
              title:
                'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
            },
          ],
        },
        {
          ...REGISTRATION.enUS,
          copy: ['Enter your details to get our services'],
        },
        {
          ...SUMMARY.enUS,
          contactDetails: [
            'HN Medi-Cal: Need help with the app or would like to cancel your account, please call {tel|18004756168|1-800-475-6168} (TTY: 711) 5 AM to 7 PM (PST), 7 days a week or email {email|us-support@babylonhealth.com}.',
            'For questions about your health plan, please call {tel|18006756110|1-800-675-6110} (TTY/TDD: 711), 24 hours a day, 7 days a week.',
          ],
        },
      ],
      footerLinks: FOOTERLINKS.USA,
    },
    'es-US': {
      steps: [
        {
          ...WELCOME.esUS,
          copy: (WELCOME.esUS.copy as CopyFunction)(planName),
          productFeatures: [
            CHECK_SYMPTOMS.esUS,
            {
              ...BOOK_APPOINTMENT.esUS,
              title:
                'Pida una cita por videollamada para hablar con un médico las 24 horas del día, los 7 días de la semana, o con un terapeuta de lunes a viernes de 7 a.m. a 7 p.m.',
            },
            {
              ...PRESCRIPTION.esUS,
              title:
                'Reciba sus artículos recetados en la farmacia local de su elección (podrían aplicarse restricciones)',
            },
          ],
        },
        {
          ...REGISTRATION.esUS,
          copy: ['Ingrese sus datos para acceder a nuestros servicios'],
        },
        {
          ...SUMMARY.esUS,
          contactDetails: [
            'HN Medi-Cal: Si necesita ayuda con la aplicación o desea cancelar su cuenta, llame al 1-800-475-6168 (TTY: 711) de 5 a. m. a 7 p. m. (PST) los 7 días de la semana o envíe un mensaje de correo electrónico a  us-support@babylonhealth.com.',
            'Si tiene preguntas sobre su plan de salud, llame al 1-800-675-6110 (TTY/TDD: 711) las 24 horas del día, los 7 días de la semana.',
          ],
        },
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const hnmcWithDnaV2Design: PartnerConfig = {
  ...hnmc,
  config: {
    ...hnmc.config,
    useDnaV2Design: true,
  },
}

export default [hnmc, hnmcWithDnaV2Design]
